import { cyan, pink, purple } from "@mui/material/colors";
import { HarmonizedViolationProgram } from "generated-graphql/graphql";

/**
 * Violations draws its programs on Paper with white bar labels, so each color
 * has to clear 3:1 against both the light and dark paper and give that label
 * 4.5:1. `violationProgramColors.test.ts` enforces both, plus the luminance band
 * that keeps the three reading as one series. Deliberately local rather than the
 * shared Insights `ProgramAreaColors`, whose steps are tuned for the Overview
 * tiles and are not ours to move.
 */
export const PROGRAM_COLORS: Record<HarmonizedViolationProgram, string> = {
  [HarmonizedViolationProgram.Water]: cyan[800],
  [HarmonizedViolationProgram.Air]: purple[400],
  [HarmonizedViolationProgram.Waste]: pink[600],
};
